import { TranslationChunksConfig, TranslationResources } from '@spartacus/core';
import { en } from './en/index';
import { frCA } from './fr-CA/index';

export const customerTicketingTranslations: TranslationResources = {
  en,
  fr_CA: frCA,
};

export const customerTicketingTranslationChunksConfig: TranslationChunksConfig = {
  customerTicketing: [
    'customerTicketing',
    'customerTicketingList',
    'createCustomerTicket',
    'customerTicketingDetails',
    'serviceTicketsForm',
  ],
};
